import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-form-option-label',
  templateUrl: './form-option-label.component.html',
  styleUrls: ['./form-option-label.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormOptionLabelComponent {
  @Input() labelFor: string | null = null;
  @Input() labelText: string | null = null;
  @Input() size: 'default' | 'small' = 'default';
  @Input() disabled: boolean = false;
}
